<template>
  <el-tabs type="border-card">
    <el-tab-pane :label="code ? '税务托运人信息详情' : '添加税务托运人信息'">
      <compAdd />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import compAdd from "./components/addcargo.vue";
export default {
  name: "CargoInform",
  components: { compAdd },
  data() {
    return {
      parentData: {},
      code: ""
    };
  },
  created() {
    this.code = this.$route.query.code;
  }
};
</script>
